export const LISTE_CIVILITE = {
  title: 'Liste des civilités',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste civilité',
  },
  actions: {
    add: 'Ajouter une civilité',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
  },
  yes: 'Oui',
  no: 'Non',
};

export const ADD_CIVILITE = {
  titleAdd: 'Ajouter une civilité',
  titleEdit: 'Modifier une civilité',
  actions: {
    cancel: 'Annuler',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
  },
  informationCivilite: {
    libelle: 'Libellé',
  },
  success: {
    add: 'La civilité a été ajoutée avec succès.',
    edit: 'La civilité a été modifiée avec succès.',
  },
};
